import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getOrderStatusMappingDataView } from "@insite/client-framework/Store/Data/OrderStatusMappings/OrderStatusMappingsSelectors";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { OrderHistoryPageContext } from "@insite/content-library/Pages/OrderHistoryPage";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, FlattenSimpleInterpolation } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    return {
        orderStatusMappings: getOrderStatusMappingDataView(state).value,
        parameter: state.pages.orderHistory.getOrdersParameter,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistorySearchFieldStatusStyles {
    statusButton?: ButtonPresentationProps;
    statusTabWrapper?: InjectableCss;
}

export const statusStyles: OrderHistorySearchFieldStatusStyles = {
    statusTabWrapper: {
        css: css`
            margin-top: 35px;
            margin-bottom: 10px;
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 40px;
                        width: 100%;
                        margin-left: 6em;
                        flex-direction: column;
                    `,
                    null,
                    css`
                        width: 100%;
                        margin-left: 40px;
                        margin-top: 38px;
                    `,
                    css`
                        width: 95%;
                        margin-left: 6em;
                        margin-top: 40px;
                    `,
                    null,
                ])}
        `,
    },
    statusButton: {
        css: css`
            margin-right: 10px;
            white-space: nowrap;
            text-align: center;
            width: 12em;
            padding: 1px;
            color: rgb(255, 255, 255);
            &:focus {
                background-color: rgb(0, 0, 255);
            }
            span {
                font-size: 12px;
                font-weight: normal;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 13px;
                        width: 16em;
                    `,
                    null,
                    css`
                        width: 13em;
                        margin-top: 14px;
                        span {
                            font-size: 11px;
                        }
                    `,
                    css`
                        width: 15em;
                        margin-top: 14px;
                    `,
                    css`
                        width: 13.5em;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    `,
                ])}
        `,
    },
};
const styles = statusStyles;

class OrderHistoryStatus extends React.Component<Props> {
    handleChange = (event: { currentTarget: { value: string } }) => {
        if (event.currentTarget.value) {
            this.props.updateSearchFields({ status: [event.currentTarget.value] });
        } else {
            this.props.updateSearchFields({ status: undefined });
        }
    };

    render() {
        const options = this.props.orderStatusMappings || [];
        return (
            <StyledWrapper {...styles.statusTabWrapper}>
                <StyledWrapper>
                    <Button onClick={this.handleChange} variant="primary" {...styles.statusButton}>
                        {translate("All")}
                    </Button>
                </StyledWrapper>
                <StyledWrapper>
                    {options.map(option => (
                        <Button
                            onClick={this.handleChange}
                            key={option.erpOrderStatus}
                            value={option.erpOrderStatus}
                            {...styles.statusButton}
                        >
                            {option.displayName}
                        </Button>
                    ))}
                </StyledWrapper>
            </StyledWrapper>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistoryStatus),
    definition: {
        group: "Order History",
        displayName: "Status Tab",
        allowedContexts: [OrderHistoryPageContext],
    },
};

export default widgetModule;
